import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./UserMenu.module.css";
import { useTranslation } from "react-i18next";

interface UserMenuProps {
  userId: string;
  userLevel: number;
  subscriptionType: string;
  handleLogin: () => void;
  handleLogout: () => void;
}

const UserMenu: React.FC<UserMenuProps> = ({
  userId,
  userLevel,
  subscriptionType,
  handleLogin,
  handleLogout,
}) => {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState<boolean>(false);
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const currentLang = i18n.language;

  void subscriptionType;

  const onClickLogout = () => {
    handleLogout();
    setIsUserMenuOpen(false);
  };

  const onClickMyPage = () => {
    navigate(`/${currentLang}/myPage`);
    setIsUserMenuOpen(false);
  };

  const onClickAdminMembers = () => {
    navigate(`/${currentLang}/admin/members`);
    setIsUserMenuOpen(false);
  };

  const onClickAdminKnowledge = () => {
    navigate(`/${currentLang}/admin/knowledge`);
    setIsUserMenuOpen(false);
  };

  const onClickAdminBlog = () => {
    navigate(`/${currentLang}/admin/blog`);
    setIsUserMenuOpen(false);
  };

  const onClickLogin = () => {
    handleLogin();
    setIsUserMenuOpen(false);
  };

  const onClickJoinIn = () => {
    navigate(`/${currentLang}/joinIn`);
    setIsUserMenuOpen(false);
  };

  return (
    <div className={styles.userMenu}>
      <button
        className={styles.button}
        onClick={() => setIsUserMenuOpen((prev) => !prev)}
      >
        {t("user_menu.account_management")}
      </button>
      <div className={`${styles.menuLinks} ${isUserMenuOpen ? styles.open : ""}`}>
        {userId !== "Guest" ? (
          <>
            {userLevel <= 1 && (
              <>
                <button className={styles.submenuButton} onClick={onClickAdminMembers}>
                  {t("admin.members", { defaultValue: "회원관리" })}
                </button>
                <button className={styles.submenuButton} onClick={onClickAdminKnowledge}>
                  지식저장소
                </button>
                <button className={styles.submenuButton} onClick={onClickAdminBlog}>
                  글관리
                </button>
              </>
            )}
            <button className={styles.submenuButton} onClick={onClickMyPage}>
              {t("user_menu.my_page")}
            </button>
            <button className={styles.submenuButton} onClick={onClickLogout}>
              {t("user_menu.logout")}
            </button>
          </>
        ) : (
          <>
            <button className={styles.submenuButton} onClick={onClickLogin}>
              {t("user_menu.login")}
            </button>
            <button className={styles.submenuButton} onClick={onClickJoinIn}>
              {t("user_menu.join")}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default UserMenu;
